var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 2.5C8.95312 2.5 0 9.77344 0 18.75C0 22.625 1.67188 26.1719 4.45312 28.9609C3.47656 32.8984 0.210938 36.4062 0.171875 36.4453C0 36.625 -0.046875 36.8906 0.0546875 37.125C0.15625 37.3594 0.375 37.5 0.625 37.5C5.80469 37.5 9.6875 35.0156 11.6094 33.4844C14.1641 34.4453 17 35 20 35C31.0469 35 40 27.7266 40 18.75C40 9.77344 31.0469 2.5 20 2.5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.08c01f759957ffca5ac8384637653599.svg";
export { ForwardRef as ReactComponent };